'use client';

import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { MdVerified, MdLocalShipping, MdVisibility, MdStore } from 'react-icons/md';
import { FaGlasses } from 'react-icons/fa';
import { IconType } from 'react-icons';

const FEATURES: { icon: IconType; label: string; sub?: string }[] = [
  {
    icon: FaGlasses,
    label: 'Melhor Qualidade / Preço',
    sub: 'As melhores marcas ao melhor preço',
  },
  {
    icon: MdVerified,
    label: 'Compra 100% Segura',
    sub: 'Pagamento protegido e encriptado',
  },
  {
    icon: MdStore,
    label: 'Entregas Grátis em Loja',
    sub: 'Recebe a tua encomenda na loja mais próxima, sem custos adicionais',
  },
  {
    icon: MdLocalShipping,
    label: 'Entrega em 2 Dias Úteis',
    sub: '*Pode variar para lentes de contacto',
  },
  {
    icon: MdVisibility,
    label: 'Profissionalismo no Serviço',
    sub: 'Equipa dedicada e pronta para ajudar',
  },
];

const InfoRow = ({
  item,
  isLast,
}: {
  item: (typeof FEATURES)[number];
  isLast: boolean;
}) => (
  <Flex
    align="center"
    gap="13px"
    px="18px"
    py="12px"
    transition="background 0.18s"
    _hover={{ bg: { base: 'rgba(0,176,202,0.03)', _dark: 'rgba(0,176,202,0.06)' } }}
    borderBottom={isLast ? 'none' : '1px solid'}
    borderBottomColor={{ base: 'rgba(0,0,0,0.055)', _dark: 'rgba(255,255,255,0.045)' }}
  >
    {/* Icon */}
    <Flex
      flexShrink={0}
      w="38px"
      h="38px"
      borderRadius="11px"
      align="center"
      justify="center"
      bg={{ base: 'rgba(0,176,202,0.08)', _dark: 'rgba(0,176,202,0.12)' }}
      border="1.5px solid"
      borderColor={{ base: 'rgba(0,176,202,0.18)', _dark: 'rgba(0,176,202,0.28)' }}
    >
      <Icon as={item.icon} w="18px" h="18px" color="#00B0CA" />
    </Flex>

    {/* Text */}
    <Box flex="1" minW="0">
      <Text
        fontSize="12px"
        fontWeight="700"
        color={{ base: '#0A1B2B', _dark: '#E2EFF5' }}
        lineHeight="1.35"
      >
        {item.label}
      </Text>
      {item.sub && (
        <Text
          fontSize="10px"
          color={{ base: 'rgba(0,0,0,0.42)', _dark: 'rgba(255,255,255,0.38)' }}
          lineHeight="1.4"
          mt="2px"
        >
          {item.sub}
        </Text>
      )}
    </Box>
  </Flex>
);

const OrderInfo = () => {
  return (
    <Flex
      pos="relative"
      w={{ base: '100%', md: '300px' }}
      bg={{ base: '#FFFFFF', _dark: '#0A1B2B' }}
      borderRadius="20px"
      border="2px solid"
      borderColor={{ base: 'rgba(0,0,0,0.07)', _dark: 'rgba(255,255,255,0.06)' }}
      boxShadow={{ base: '0 4px 20px rgba(0,0,0,0.06)', _dark: '0 4px 28px rgba(0,0,0,0.4)' }}
      flexDir="column"
      overflow="hidden"
    >

      {/* Header */}
      <Flex align="center" gap="9px" px="18px" pt="14px" pb="12px">
        <Box
          w="5px"
          h="5px"
          borderRadius="full"
          bg="#00B0CA"
          boxShadow="0 0 6px rgba(0,176,202,0.7)"
          flexShrink={0}
        />
        <Text
          fontSize="10px"
          fontWeight="700"
          letterSpacing="1.2px"
          textTransform="uppercase"
          color={{ base: 'rgba(0,0,0,0.35)', _dark: 'rgba(255,255,255,0.3)' }}
        >
          Porquê escolher‑nos?
        </Text>
      </Flex>

      {/* Divider */}
      <Box mx="18px" h="1px" bg={{ base: 'rgba(0,0,0,0.06)', _dark: 'rgba(255,255,255,0.05)' }} mb="2px" />

      {/* Feature rows */}
      {FEATURES.map((item, i) => (
        <InfoRow key={i} item={item} isLast={i === FEATURES.length - 1} />
      ))}

      <Box h="6px" />
    </Flex>
  );
};

export default OrderInfo;

